import { Store } from "bernie-plugin-mobx";
import { SerializedData } from "bernie-core";
import { action, observable } from "mobx";
import { Template } from "typings/flexFramework/FlexDefinitions";
import { Logger } from "bernie-logger";

/**
 * Mobx store that saves the template data structure for a given page.
 * - bffResponse.template is only populated on the template path
 */
export class TemplateStore extends Store {
  @observable
  public template: Template;

  /* istanbul ignore next */
  public constructor(state: SerializedData = {}, logger: Logger) {
    super(state, logger);
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  /**
   * initializes TemplateStore with data from other stores. Called from controller
   * @param  {FlexBffTemplateResponse} template
   * @returns void
   */
  @action
  public setup(template?: Template) {
    if (!template) {
      return;
    }

    this.template = template;
  }
}
